import { ComponentType, useEffect } from 'react';
import { BrowserRouter as Router, Navigate, Route, Routes } from 'react-router';
import Sidenav from './common/shell/sidenav/sidenav.component';
import { NotificationContainer } from './common/ui-components/notification';
import { AuthState, withAuth } from './domains/auth/context/auth-context';
import Authentication from './domains/auth/context/auth.component';
import Login from './domains/auth/views/login/login.component';
import AuthRedirect from './domains/auth/views/redirect/redirect.component';
import { updateUserLanguage } from './domains/users/user-service';
import { shouldLoadLocaleFromUser } from './i18n/configurations';
import { LocaleContext, LocaleContextState, LocaleProvider } from './i18n/locale';
import Routing from './routing/routes.component';
import './app.component.scss';
import { ErrorBoundary } from './common/error-boundary';

const loginRoute = '/auth/login';

const Application = () => (
    <div className="app">
        <Sidenav className="app__sidenav" />
        <ErrorBoundary>
            <Routing />
        </ErrorBoundary>
    </div>
);

const ApplicationRoutes = ({
    loggedIn,
    user,
    switchLanguage,
    lang
}: AuthState & LocaleContextState) => {
    useEffect(() => {
        if (user?.language != null && shouldLoadLocaleFromUser()) {
            switchLanguage(user.language);
        }
    }, [user?.language]);
    useEffect(() => {
        if (!loggedIn) {
            return;
        }
        updateUserLanguage(lang);
    }, [lang]);

    return (
        <Routes>
            <Route path={loginRoute} element={<Login />} />
            <Route path="/auth/redirect" element={<AuthRedirect />} />
            {loggedIn && <Route path="*" element={<Application />} />}
            {!loggedIn && <Route path="*" element={<Navigate to={loginRoute} replace />} />}
        </Routes>
    );
};

const AppRoutes: ComponentType<LocaleContextState> = withAuth()(
    ApplicationRoutes
) as ComponentType<LocaleContextState>;

const App = (
    <NotificationContainer>
        <LocaleProvider>
            <Router>
                <Authentication>
                    <LocaleContext.Consumer>
                        {props => <AppRoutes {...props} />}
                    </LocaleContext.Consumer>
                </Authentication>
            </Router>
        </LocaleProvider>
    </NotificationContainer>
);

export default App;
